import React, { useCallback, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../components/Popup/PopupHeader';
import PopupBody from '../../../components/Popup/PopupBody';
import * as actions from '../../../../redux/user/actions.user';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import BillingForms from '../BillingForms/BillingForms';
import errorMessages from '../../../../const/errorMessages';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import { reachMetrikaGoal } from '../../../../services/MetrikaService';


function ApplyPromoCodePopup({
    title,
    amount,
    nextPlan,
    onBillingFinishedCb,
    onClose,
    store,
    error
}) {

    useEffect(() => {
        reachMetrikaGoal('viewedAddFundsModal');
    });

    const onCloseCb = useCallback(() => {
        reachMetrikaGoal('closeAddFundsModal');
        onClose();
    }, [onClose]);

    return (
        <PopupWrapper className="billing-popup">
            <PopupHeader
                title={title !== undefined ? title : 'Choose your payment method'}
                onCancel={onBillingFinishedCb || onCloseCb} />
            <PopupBody className="billing-popup_body">
                {error && <span className="billing-popup_err-msg">{errorMessages[error]}</span>}
                <BillingForms
                    title=""
                    nextPlan={nextPlan}
                    amount={amount}
                    store={store}
                    hideCardsBtn={true}
                    hideStripeBtn={true}
                    hidePaypalBtn={true}
                    expandPromoCodeSection={true}
                    onBillingFinishedCb={onBillingFinishedCb} />
            </PopupBody>
        </PopupWrapper>
    );
}

function mapStateToProps({ user }, ownProps) {
    return {
        balance: user.balance,
        paidUntilTs: user.paidUntilTs,
        currentPlan: user.currentPlan,
        billingStatus: user.billingStatus,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPlans: () => dispatch(actions.getPlans()),
        changePlan: (param) => asyncDispatch(actions.changePlan, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withClickOutsideOnOverlay(ApplyPromoCodePopup));
